import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const SectionWrapper = styled.div`
  border: none;
  padding: 28px 24px;
  position: relative;

  ${media.md`
    padding:  28px 24px;
    border: 1px solid #efefef;
    border-radius: 3px;
    margin-top: 20px;
  `}
`;
